// 获取当前域名（支持服务器端和客户端）
export const useCurrentDomain = () => {
  if (process.server) {
    // 服务器端获取域名
    const headers = useRequestHeaders()
    const host = headers.host || ''
    const protocol = useCurrentProtocol()
    return `${protocol}://${host}`
  } else {
    // 客户端获取域名
    return window.location.origin
  }
}

// 获取当前主机名（不包含协议）
export const useCurrentHostname = () => {
  if (process.server) {
    const headers = useRequestHeaders()
    return headers.host || ''
  } else {
    return window.location.hostname
  }
}

// 获取当前协议
export const useCurrentProtocol = () => {
  if (process.server) {
    const headers = useRequestHeaders()
    const host = headers.host || ''

    // 如果是 localhost，使用 http
    if (host.includes('localhost') || host.includes('127.0.0.1')) {
      return 'http'
    }

    // 其他域名默认为 https
    return 'https'
  } else {
    // 客户端
    const hostname = window.location.hostname

    // 如果是 localhost，使用 http
    if (hostname.includes('localhost') || hostname.includes('127.0.0.1')) {
      return 'http'
    }

    // 其他域名默认为 https
    return window.location.protocol.replace(':', '') || 'https'
  }
}
